import { render, staticRenderFns } from "./AdmissionNotice.vue?vue&type=template&id=fc778fb2&scoped=true&"
import script from "./AdmissionNotice.vue?vue&type=script&lang=js&"
export * from "./AdmissionNotice.vue?vue&type=script&lang=js&"
import style0 from "./AdmissionNotice.vue?vue&type=style&index=0&id=fc778fb2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc778fb2",
  null
  
)

export default component.exports